<!-- 账号流水 -->
 <template>
  <div class="view-container">
    <div class="content-header">
      <el-date-picker
        style="width: 430px"
        v-model="form.value1"
        type="datetimerange"
        :picker-options="pickerOptions"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        align="left"
      >
      </el-date-picker>
      <el-button
        type="primary"
        style="margin-left: 10px"
        @click="getWithdrawalRecord()"
        >查询</el-button
      >
    </div>
    <!-- 表格 -->
    <div class="tab-view" v-loading="loading">
      <el-table
        :data="tableData"
        max-height="500"
        :header-cell-style="{
          backgroundColor: ' rgb(235, 237, 244)',
          color: 'black',
          fontSize: '14px',
          fontWeight: '600',
        }"
      >
        <el-table-column fixed prop="orderNo" label="提现单号" width="200">
        </el-table-column>
        <el-table-column prop="withdrawalType" label="提现方式" width="100">
        </el-table-column>
        <el-table-column prop="accountName" label="姓名" width="150">
        </el-table-column>
        <el-table-column prop="account" label="账号" width="150">
        </el-table-column>
        <el-table-column prop="amount" label="提现金额" width="150">
        </el-table-column>
        <el-table-column prop="fee" label="手续费" width="150">
        </el-table-column>
        <el-table-column prop="realAmount" label="实际到账" width="150">
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">待审核</span>
            <span v-else-if="scope.row.status == 2" style="color: green"
              >成功</span
            >
            <span v-else-if="scope.row.status == 3">拒绝</span>
            <span v-else-if="scope.row.status == 4" style="color: red"
              >失败</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="申请时间" width="200">
        </el-table-column>
        <el-table-column prop="updateTime" label="处理时间" width="200">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div
      style="
        margin-top: 30px;
        display: flex;
        justify-content: flex-end;
        padding-right: 30px;
      "
    >
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="fundRecord()"
      />
    </div>
  </div>
</template>
 
 <script>
import http from "@/utils/http/axios";
export default {
  data() {
    return {
      total: 0,
      loading: false,
      form: {
        value1: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "本月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(1);
              end.setMonth(end.getMonth() + 1);
              end.setDate(0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "今年至今",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      tableData: [],
    };
  },
  mounted() {
    this.getWithdrawalRecord();
  },
  methods: {
    handleSizeChange() {},
    handleCurrentChange() {},
    getWithdrawalRecord() {
      this.loading = true;
      let params = {};
      if (this.form.value1 && this.form.value1.length === 2) {
        const startDate = this.formatDate(this.form.value1[0]);
        const endDate = this.formatDate(this.form.value1[1]);
        params = { startDate, endDate };
      }
      http
        .get(`/user/withdrawal/record`, { params })
        .then((response) => {
          this.loading = false;
          this.total = response.total;
          if (response.code === 200) {
            this.tableData = response.rows.map((row) => ({
              ...row,
              createTime: this.convertDate(row.createTime),
              auditTime: this.convertDate(row.auditTime),
              updateTime: this.convertDate(row.updateTime),
            }));
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error("发生意外异常");
        });
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    convertDate(isoDateString) {
      const date = new Date(isoDateString);
      return this.formatDate(date);
    },
  },
};
</script>
 
 <style lang="scss" scoped>
::-webkit-scrollbar {
  width: 6px;
  height: 1px;
}

.view-container {
  background-color: white;
  height: 100%;
  padding-left: 30px;
  padding-top: 20px;
  .content-header {
    height: 50px;
    display: flex;
    align-items: center;
    padding-bottom: 20px;
  }
  .tab-view {
    border: 2px solid #ebeef5;
    border-radius: 5px;
    padding: 0px;
  }
}
</style>